// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Header
 */
.row.header {
  height: 60px;
  background: #fff;
  margin-bottom: 15px;
}
.row.header > div:last-child {
  padding-right: 0;
}
.row.header .meta .page {
  font-size: 17px;
  padding-top: 11px;
}
.row.header .meta .breadcrumb-links {
  font-size: 10px;
}
.row.header .meta div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row.header .login a {
  padding: 18px;
  display: block;
}
.row.header .user {
  min-width: 130px;
}
.row.header .user > .item {
  width: 65px;
  height: 60px;
  float: right;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
}
.row.header .user > .item a {
  color: #919191;
  display: block;
}
.row.header .user > .item i {
  font-size: 20px;
  line-height: 55px;
}
.row.header .user > .item img {
  width: 40px;
  height: 40px;
  margin-top: 10px;
  border-radius: 2px;
}
.row.header .user > .item ul.dropdown-menu {
  border-radius: 2px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
}
.row.header .user > .item ul.dropdown-menu .dropdown-header {
  text-align: center;
}
.row.header .user > .item ul.dropdown-menu li.link {
  text-align: left;
}
.row.header .user > .item ul.dropdown-menu li.link a {
  padding-left: 7px;
  padding-right: 7px;
}
.row.header .user > .item ul.dropdown-menu:before {
  position: absolute;
  top: -7px;
  right: 23px;
  display: inline-block;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(0, 0, 0, 0.2);
  border-left: 7px solid transparent;
  content: '';
}
.row.header .user > .item ul.dropdown-menu:after {
  position: absolute;
  top: -6px;
  right: 24px;
  display: inline-block;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #ffffff;
  border-left: 6px solid transparent;
  content: '';
}
`, "",{"version":3,"sources":["webpack://./layout/resources/less/header.less"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAAI;EACI,gBAAA;AAER;AAPA;EASY,eAAA;EACA,iBAAA;AACZ;AAXA;EAaY,eAAA;AACZ;AAdA;EAgBY,mBAAA;EACA,gBAAA;EACA,uBAAA;AACZ;AAnBA;EAuBY,aAAA;EACA,cAAA;AADZ;AAvBA;EA4BQ,gBAAA;AAFR;AAGQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;AADZ;AALQ;EAQQ,cAAA;EACA,cAAA;AAAhB;AATQ;EAYQ,eAAA;EACA,iBAAA;AAAhB;AAbQ;EAgBQ,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAAhB;AAnBQ;EAsBQ,kBAAA;EACA,kDAAA;EACA,0CAAA;AAAhB;AAxBQ;EA0BY,kBAAA;AACpB;AA3BQ;EA6BY,gBAAA;AACpB;AA9BQ;EA+BgB,iBAAA;EACA,kBAAA;AAExB;AAlCQ;EAqCQ,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,2CAAA;EACA,kCAAA;EACA,WAAA;AAAhB;AA5CQ;EA+CQ,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,gCAAA;EACA,kCAAA;EACA,WAAA;AAAhB","sourcesContent":["/**\n * Header\n */\n.row.header {\n    height: 60px;\n    background: #fff;\n    margin-bottom: 15px;\n    & > div:last-child {\n        padding-right: 0;\n    }\n    .meta {\n        .page {\n            font-size: 17px;\n            padding-top: 11px;\n        }\n        .breadcrumb-links {\n            font-size: 10px;\n        }\n        div {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n    .login {\n        a {\n            padding: 18px;\n            display: block;\n        }\n    }\n    .user {\n        min-width: 130px;\n        & > .item {\n            width: 65px;\n            height: 60px;\n            float: right;\n            display: inline-block;\n            text-align: center;\n            vertical-align: middle;\n            a {\n                color: #919191;\n                display: block;\n            }\n            i {\n                font-size: 20px;\n                line-height: 55px;\n            }\n            img {\n                width: 40px;\n                height: 40px;\n                margin-top: 10px;\n                border-radius: 2px;\n            }\n            ul.dropdown-menu {\n                border-radius: 2px;\n                -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.05);\n                box-shadow: 0 6px 12px rgba(0,0,0,.05);\n                .dropdown-header {\n                    text-align: center;\n                }\n                li.link {\n                    text-align: left;\n                    a {\n                        padding-left: 7px;\n                        padding-right: 7px;\n                    }\n                }\n            }\n            ul.dropdown-menu:before {\n                position: absolute;\n                top: -7px;\n                right: 23px;\n                display: inline-block;\n                border-right: 7px solid transparent;\n                border-bottom: 7px solid rgba(0, 0, 0, 0.2);\n                border-left: 7px solid transparent;\n                content: '';\n            }\n            ul.dropdown-menu:after {\n                position: absolute;\n                top: -6px;\n                right: 24px;\n                display: inline-block;\n                border-right: 6px solid transparent;\n                border-bottom: 6px solid #ffffff;\n                border-left: 6px solid transparent;\n                content: '';\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
